/** Module-level flag so API modules can serve fixtures without React context. */
let tutorialFixtureActive = false;
let tutorialFixtureEpoch = 0;

export function setTutorialFixtureActive(active: boolean): void {
  if (active && !tutorialFixtureActive) tutorialFixtureEpoch += 1;
  tutorialFixtureActive = active;
}

export function getTutorialFixtureEpoch(): number {
  return tutorialFixtureEpoch;
}

export function isTutorialFixtureActive(): boolean {
  return tutorialFixtureActive;
}
